import { apiFetch } from './api';
export interface ApiUser {
  id: string;
  email: string;
  role?: string;
  newsletterOptIn?: boolean;
}

interface AuthRequestBody {
  email: string;
  role?: string;
  newsletterOptIn?: boolean;
  turnstileToken?: string;
}

export const requestMagicLink = (payload: AuthRequestBody) =>
  apiFetch<{ ok: true }>(`/auth/request`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const verifyMagicLink = (token: string) =>
  apiFetch<{ ok: true; user: ApiUser }>(`/auth/verify`, {
    method: 'POST',
    body: JSON.stringify({ token }),
  });

export const logout = () =>
  apiFetch<{ ok: true }>(`/auth/logout`, {
    method: 'POST',
  });
